/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    async ready(registration) {
      if (registration.sync) {
        await registration.sync.register("airways3-app-background-sync");
        //console.log("sync registered: airways3-app-background-sync");
      }
    },
    /*
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    */
    updated(registration) {
      document.dispatchEvent(
        new CustomEvent("swUpdated", { detail: registration })
      );
    },
    /*
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },*/
  });
}
